import { render } from "./FormularioPlanoMatricula.vue?vue&type=template&id=7877ab25&scoped=true"
import script from "./FormularioPlanoMatricula.vue?vue&type=script&lang=js"
export * from "./FormularioPlanoMatricula.vue?vue&type=script&lang=js"

import "./FormularioPlanoMatricula.vue?vue&type=style&index=0&id=7877ab25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7877ab25"]])

export default __exports__